var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyStateBox = function SvgEmptyStateBox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.771 111.56C93.9037 95.47 63.2343 55.3562 75.492 23.6204C90.8141 -16.0495 158.137 12.1787 134.672 50.5439C115.9 81.236 58.8122 41.8668 32.6147 18.3457",
    stroke: "#BBDEFB",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3718 100.326L192.659 100.326L192.659 188.238C192.659 195.378 186.871 201.166 179.731 201.166L23.3 201.166C16.1599 201.166 10.3718 195.378 10.3718 188.238L10.3718 100.326Z",
    fill: "url(#paint0_linear_1_277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.885 100.326L192.659 100.326L192.659 188.472C192.659 195.483 186.976 201.166 179.966 201.166L142.885 201.166L142.885 100.326Z",
    fill: "url(#paint1_linear_1_277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.579 71.8866L202.998 71.8865L192.656 100.329L142.236 100.329L152.579 71.8866Z",
    fill: "url(#paint2_linear_1_277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3723 100.326L142.24 100.326L135.462 127.437C134.887 129.739 132.818 131.354 130.445 131.354L9.23868 131.354C5.8744 131.354 3.40583 128.192 4.22179 124.928L10.3723 100.326Z",
    fill: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 149.995,
    y: 110.669,
    width: 36.1989,
    height: 10.3425,
    rx: 2.58564,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.9266,
    y: 15.7283,
    width: 4,
    height: 9,
    rx: 2,
    transform: "rotate(131.039 31.9266 15.7283)",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3517 20.9629C27.2963 21.8793 26.5085 22.5773 25.5921 22.5219C24.6757 22.4665 23.9777 21.6786 24.0331 20.7622L24.2338 17.4436C24.2892 16.5272 25.077 15.8292 25.9934 15.8847C26.9099 15.9401 27.6078 16.7279 27.5524 17.6443L27.3517 20.9629Z",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7439 18.6895C20.8757 18.9878 19.93 18.5258 19.6316 17.6575C19.3333 16.7892 19.7954 15.8435 20.6636 15.5452L23.8079 14.4649C24.6762 14.1666 25.6219 14.6287 25.9202 15.4969C26.2185 16.3652 25.7565 17.3109 24.8882 17.6092L21.7439 18.6895Z",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6189 13.7632C34.5189 13.582 35.1016 12.7055 34.9204 11.8055C34.7392 10.9055 33.8627 10.3228 32.9627 10.504L29.7034 11.1602C28.8034 11.3414 28.2207 12.2179 28.4019 13.1179C28.5831 14.0179 29.4596 14.6006 30.3596 14.4194L33.6189 13.7632Z",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5942 8.5223C30.77 7.62121 30.182 6.74822 29.2809 6.57243C28.3798 6.39665 27.5068 6.98463 27.331 7.88572L26.6944 11.1489C26.5187 12.05 27.1066 12.923 28.0077 13.0988C28.9088 13.2745 29.7818 12.6866 29.9576 11.7855L30.5942 8.5223Z",
    fill: "#BBDEFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_277",
    x1: 100.869,
    y1: 113.901,
    x2: 102.463,
    y2: 201.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_277",
    x1: 157.214,
    y1: 105.173,
    x2: 157.957,
    y2: 201.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDEFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_277",
    x1: 163.56,
    y1: 64.3729,
    x2: 161.293,
    y2: 105.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDEFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202.972,
    height: 202.972,
    fill: "white",
    transform: "translate(0.0275269 -0.000152588)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateBox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-state-box.9d9ffcb941b5097cb8dabbf0f8117a09.svg";